'use strict'

import {Enum} from '@/app/model/base/enum'

/**
 * Темы
 */
export const values = {
  SMARTIX: 'smartix',
  PETROVICH_BASE: 'petrovich-base',
  PETROVICH_ADDITIONAL: 'petrovich-additional'
}

class ThemeTypes extends Enum {

}

export default ThemeTypes.initEnum(values)
